module.exports = __webpack_public_path__ + "fonts/AlimamaShuHeiTi-Bold.9268c326.ttf";